import {Box, Stack, Typography, Grid2 as Grid, Container} from "@mui/material";
import {STYLE} from "./STYLES";
import {BORDER_RADIUS_OUTER} from "../../config/themes/theme";
import {MaterialSymbol, SymbolCodepoints} from "react-material-symbols";

interface FeatureCardProps {
  title: string;
  description: string;
  icon: SymbolCodepoints;
}

function FeatureCard({title, description, icon}: FeatureCardProps) {
  return (
    <Stack spacing={1.5} sx={STYLE.cmnSectionFeatureCard}>
      <Stack direction="row" alignItems="center" spacing={1} color={"inherit"}>
        <MaterialSymbol
          icon={icon}
          style={STYLE.cmnSectionFeatureCardIcon}
          fill
        />
        <Typography sx={STYLE.cmnSectionFeatureCardTitle}>{title}</Typography>
      </Stack>
      <Typography sx={STYLE.cmnSectionFeatureCardDescription}>
        {description}
      </Typography>
    </Stack>
  );
}

export default function CommonSection() {
  const features = [
    {
      title: "Faster analysis",
      description:
        "Stay ahead of the curve with our comprehensive trend reports.",
      icon: "looks_one" as SymbolCodepoints,
    },
    {
      title: "Faster analysis",
      description: "Expand your reach with our multilingual support services.",
      icon: "looks_two" as SymbolCodepoints,
    },
    {
      title: "Faster analysis",
      description:
        "Stay ahead of the curve with our comprehensive trend reports.",
      icon: "looks_3" as SymbolCodepoints,
    },
    {
      title: "Faster analysis",
      description: "Expand your reach with our multilingual support services.",
      icon: "looks_4" as SymbolCodepoints,
    },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        py: {xs: 6, md: 8},
        display: "flex",
        justifyContent: "center",
      }}>
      <Grid container spacing={4} width={"100%"}>
        <Grid size={5.5} pl={{xs: 0, md: 2}}>
          <Stack spacing={2}>
            <Typography variant="h1" sx={STYLE.sectionSecondaryTitle}>
              Problemsets
            </Typography>
            <Typography sx={STYLE.sectionSubtitle}>
              Preparation made faster and smarter. PrepGenie is the best way to
              get exam-ready.
            </Typography>

            <Box height={16} />

            <Box
              sx={{
                height: "1px",
                width: "100%",
                bgcolor: "#E2E8F0",
              }}
            />
            <Box height={24} />

            <Grid container spacing={4}>
              {features.map((feature, index) => (
                <Grid size={6} key={index} sx={{mb: 3}}>
                  <FeatureCard
                    title={feature.title}
                    description={feature.description}
                    icon={feature.icon}
                  />
                </Grid>
              ))}
            </Grid>
          </Stack>
        </Grid>

        <Grid size={6.5}>
          <Box
            sx={{
              width: "100%",
              height: "100%",
              minHeight: "400px",
              borderRadius: BORDER_RADIUS_OUTER,
              background:
                "linear-gradient(262deg, #F2D3F9 0%, #F1DFF7 23.14%, #F1E6DB 46.76%, #F1ECE5 71.35%, #DCF4EB 100.27%)",
              backgroundImage: "url(/landing/bg-gradient.png)",
              backgroundSize: "cover",
              backgroundPositionX: "center",
              backgroundPositionY: "top",
              backgroundRepeat: "no-repeat",
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
